import React from "react";
import PropTypes from "prop-types";
import style from "./ListPagination.module.sass";

function ListPagination({
  page,
  totPages,
  clickOnPrevPage,
  clickOnNextPage,
  translations,
  onPageChange,
}) {
  const handleSelectChange = (e) => {
    const newPage = parseInt(e.target.value, 10);
    if (onPageChange) {
      onPageChange(newPage);
    }
  };

  const renderOptions = () => {
    const opts = [];
    for (let i = 1; i <= totPages; i++) {
      opts.push(
        <option key={i} value={i}>
          {`${i} ${translations?.of || "su"} ${totPages}`}
        </option>
      );
    }
    return opts;
  };

  return (
    <div className={style.ListPagination}>
      <span
        className={`${style.ListPaginationPrev} ${page === 1 ? style.disabled : ""}`}
        onClick={page === 1 ? undefined : clickOnPrevPage}
      >
        ‹
      </span>

      <div className={`${style.ListPaginationDropdownWrapper} ${totPages === 1 ? style.disabled : ""}`}>
        <select id="page-select"
          className={style.ListPaginationSelect}
          value={page}
          onChange={handleSelectChange}
        >
          {renderOptions()}
        </select>
        <i className={`fa fa-angle-down ${style.iconOrder}`}></i>
      </div>

      <span
        className={`${style.ListPaginationNext} ${page === totPages ? style.disabled : ""}`}
        onClick={page === totPages ? undefined : clickOnNextPage}
      >
        ›
      </span>
    </div>
  );
}

ListPagination.propTypes = {
  page: PropTypes.number.isRequired,
  totPages: PropTypes.number.isRequired,
  clickOnPrevPage: PropTypes.func.isRequired,
  clickOnNextPage: PropTypes.func.isRequired,
  onPageChange: PropTypes.func,
  translations: PropTypes.object,
};

export default ListPagination;
